
import {
  CareerSiteBrandConfigurationV2Response,
  CareerSiteV2Service,
} from 'api-clients/monolith';
import { useEffect, useState } from 'react';

export function useBrandConfigV2(
  accountSlug: string,
  brandId: string,
  locale?: string,
) {
  const [data, setData] = useState<CareerSiteBrandConfigurationV2Response>();
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const fetchData = () => {
      setIsFetching(true);
      CareerSiteV2Service.getInternalApiCareerSiteV2BrandsConfiguration({
        account_slug: accountSlug,
        brand_id: brandId,
        locale,
      })
        .then((result: CareerSiteBrandConfigurationV2Response) => {
          setData(result);
        })
        .catch(() => {
          // fetch error — not re-thrown
        })
        .finally(() => {
          setIsFetching(false);
        });
    };
    void fetchData();
  }, [accountSlug, brandId, locale]);

  return { data, isFetching, setData };
}
